import { createStore } from 'zustand';
import { persist } from 'zustand/middleware';

export type LlmChatStore = {
  scrollBehavior: ScrollBehavior | false;

  // Actions
  setScrollBehavior: (scrollBehavior: ScrollBehavior | false) => void;
};

export const llmChatStore = createStore<LlmChatStore>()(
  persist(
    (set) => ({
      scrollBehavior: false,
      setScrollBehavior: (scrollBehavior) => set({ scrollBehavior }),
    }),
    { name: 'llmChatStore' },
  ),
);
